import { Route } from 'react-router-dom';
import { LazyDisplayDescriptionPickerWrapper } from '../screens/DisplayDescriptionPicker/LazyDisplayDescriptionPickerWrapper';
import { LazyAccessTypePickerWrapper } from '../screens/AccessTypePicker/LazyAccessTypePickerWrapper';
import { LazyAuthenticationTypePicker } from '../screens/AuthenticationTypePicker/LazyAuthenticationTypePicker';
import { LazyGroupPicker } from '../screens/ProviderGroupPicker/LazyProviderGroupPickerWrapper';
import { LazyFinancialInstitutionPickerWrapper } from '../screens/FinancialInstitutionPicker/LazyFinancialInstitutionPickerWrapper';
import { LazyCredentialsTypePickerWrapper } from '../screens/CredentialsTypePicker/LazyCredentialsTypePickerWrapper';
import { LazyFinancialServicePickerWrapper } from '../screens/FinancialServicePicker/LazyFinancialServicePickerWrapper';

/** BaseRoutes
 * This component holds functionality to take one from /:version/:productType/:productDimension to
 *   /:version/:productType/:productDimension/:providerName, i.e. filtering out one provider.name.
 */
export enum BaseRoutePath {
  PROVIDER_GROUP_PICKER = '/:version/:productType/:productDimension',
  FINANCIAL_INSTITUTION_PICKER = '/:version/:productType/:productDimension/group/:groupDisplayName',
  AUTHENTICATION_TYPE_PICKER = '/:version/:productType/:productDimension/authentication-type/:financialInstitutionId',
  ACCESS_TYPE_PICKER = '/:version/:productType/:productDimension/access-type/:financialInstitutionId/:authenticationUserType',
  CREDENTIALS_TYPE_PICKER = '/:version/:productType/:productDimension/credentials-type/:financialInstitutionId/:authenticationUserType/:accessType',
  DISPLAY_DESCRIPTION_PICKER = '/:version/:productType/:productDimension/display-description/:financialInstitutionId/:authenticationUserType/:accessType/:credentialsType',
  FINANCIAL_SERVICE_PICKER = '/:version/:productType/:productDimension/financial-service/:financialInstitutionId',
}

export const BaseRoutes = () => {
  return (
    <>
      <Route
        path={BaseRoutePath.CREDENTIALS_TYPE_PICKER}
        component={LazyCredentialsTypePickerWrapper}
      />
      <Route
        path={BaseRoutePath.DISPLAY_DESCRIPTION_PICKER}
        component={LazyDisplayDescriptionPickerWrapper}
      />
      <Route
        path={BaseRoutePath.FINANCIAL_INSTITUTION_PICKER}
        component={LazyFinancialInstitutionPickerWrapper}
      />
      <Route path={BaseRoutePath.ACCESS_TYPE_PICKER} component={LazyAccessTypePickerWrapper} />
      <Route
        path={BaseRoutePath.AUTHENTICATION_TYPE_PICKER}
        component={LazyAuthenticationTypePicker}
      />
      <Route
        path={BaseRoutePath.FINANCIAL_SERVICE_PICKER}
        component={LazyFinancialServicePickerWrapper}
      />
      <Route exact path={BaseRoutePath.PROVIDER_GROUP_PICKER} component={LazyGroupPicker} />
    </>
  );
};
